import { CampaignsOverviewStats, campaignsOverviewStatsSchema } from "@signalist/shared-types";

import { ListOwnership } from "@/enum/list.enum";

import { api } from "@/redux/api";

import { ListResponse, ListResponseSchema } from "../../pages/List/schema/list";

/**
 * Campaigns-overview aggregates (PREC-3880): the stat strip (running / contacted / replied /
 * positive for the active ownership scope) and the My / Team / All campaign counts for the tab
 * bubbles. Split into its own `injectEndpoints` file because the main `list.api.ts` is at the
 * file-length ratchet ceiling and may not grow (same split as `list-ownership-counts.api.ts`).
 *
 * Tagged `List` so the numbers refetch when a list or campaign mutation invalidates the broad
 * `List` tag (pause/resume, archive, create, …).
 */
export const campaignsOverviewApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getCampaignsOverview: builder.query<CampaignsOverviewStats, { ownership?: ListOwnership }>({
			query: ({ ownership }) => ({
				url: "list/campaigns-overview",
				params: ownership ? { ownership } : undefined,
				responseSchema: campaignsOverviewStatsSchema,
			}),
			providesTags: ["List"],
		}),
		/**
		 * Lean lists for the New-Campaign modal's list picker. A separate endpoint (same URL as
		 * `getLeanLists`) on purpose: the list slice's matcher listens on `getLeanLists`, so the
		 * picker's fetch must not clobber the Campaigns table's rows behind the open modal.
		 */
		getCampaignListPicker: builder.query<ListResponse, { searchValue?: string }>({
			query: ({ searchValue }) => ({
				url: "list/lean",
				params: {
					page: 1,
					limit: 50,
					archived: false,
					...(searchValue ? { searchValue } : {}),
				},
				responseSchema: ListResponseSchema,
			}),
			providesTags: ["List"],
		}),
	}),
});

export const { useGetCampaignsOverviewQuery, useGetCampaignListPickerQuery } = campaignsOverviewApi;
